import React from 'react';
import { Avatar, useIsMobileResolution } from '@philips-internal/oswald-ui-components';
import { Size } from '@philips-internal/oswald-ui-constants';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { foundationContext } from '../../../../index.js';
function UserAvatar(props) {
    const isMobile = useIsMobileResolution();
    const user = foundationContext.getUser();
    const onAvatarClick = () => {
        const { onClick } = props;
        if (isFunction(onClick)) {
            onClick(new ClickEvent());
        }
    };
    return (React.createElement("div", { className: "c-spotlight__section c-spotlight__user", slot: "header" },
        React.createElement("div", { className: "c-spotlight__avatar", onClick: onAvatarClick },
            React.createElement(Avatar, { image: user?.image, size: Size.SMALL, subtitle: isMobile ? user?.username : '', title: user?.name }))));
}
export { UserAvatar, };
//# sourceMappingURL=user-avatar.js.map